<!-- 组件说明 -->
<template>
  <div class="bargain-container">
    <div class="banner"></div>
   <div v-if="showtoggleList">
      <div class="con" v-if="toggleList.length">
      <div class="toggle">
        <div
          class="toggle-item c-pointer"
          :class="[activeId == item.id ? 'active-toggle' : '']"
          @click="handlechange(index,item.id)"
          v-for="(item,index) in toggleList"
          :key="index"
        >
          {{ item.name }}
        </div>
      </div>

    
    </div>
    <div class="container" v-if="toggleList.length"> 
      <div class="con">
       <div class="list-header">
        <div class="title">
          <i></i>
          <span>活动商品列表</span>
        </div>
        <div class="listBtn">
          <div
            class="list c-pointer"
            :class="{ active: type == 1 }"
            @click="showType(1)"
          >
            <img :src="require('@/assets/images/icon_c1.png')" v-if="type == 2" alt="" />
            <img :src="require('@/assets/images/icon_c2.png')" v-else alt="" />
            <span>列表</span>
          </div>
          <div
            class="table c-pointer"
            :class="{ active: type == 2 }"
            @click="showType(2)"
          >
            <img :src="require('@/assets/images/icon_d1.png')" v-if="type == 1" alt="" />
            <img :src="require('@/assets/images/icon_d2.png')" v-else alt="" />
            <span>表格</span>
          </div>
        </div>
      </div>
    <div   v-if="toggleList.length">
    
      <goodslistceil2 v-if="type == 1" :goodsList='specialGoods[pageNumber-1]' :status = '1'></goodslistceil2>
      <goodslistceil v-else :goodsList='specialGoods[pageNumber-1]' :status = '1'></goodslistceil>
    </div>
      <el-pagination
        class="pagination"
        background 
        layout="prev, pager, next"
        :page-size="pageSize"
        @current-change="changepage"
        :total="total"
        :current-page="pageNumber"
        v-if="specialGoods.length"
        >
      </el-pagination>
      </div>
    </div>
        <div class="empty con" v-if="toggleList.length  == 0">
           <div class="empty-img">
             <img :src="require('@/assets/images/all_hd.png')" alt="">
           </div>
      <div class="empty-con">
        <h5>暂无限时特价活动</h5>
        <p>近期暂无限时特价活动，请继续关注限时特价活动</p>
      </div>
    </div>
   </div>
    <!-- <qrcode  :top =" 525"></qrcode> -->
  </div>
</template>

<script>
import goodslistceil from "@/components/goods-list-ceil";
import goodslistceil2 from "@/components/goods-list-ceil-2";
import qrcode from "@/components/plugins/qrcode"
export default {
  components: { goodslistceil, goodslistceil2 ,qrcode},
  data() {
    return {
      type: 1, //1列表  2表格
      toggleList: [],
      activeId: 0,
      specialGoods:[],
      id:'',
      total:'',
      pageSize:8,
      pageNumber:1,
      showtoggleList:false
 
    };
  },
  computed: {},
  methods: {
    showType(type) {
      this.type = type;
    },
    handlechange(i,id) {
      this.activeId = id;
      this.id = id
      this.changepage(1)
    },
    changepage(val){
       this.pageNumber = val
    },
  	group(array, subGroupLength) {
				let index = 0;
				let newArray = [];
				while(index < array.length) {
						newArray.push(array.slice(index, index += subGroupLength));
				}
				return newArray;
		},
    getSpecialGoods(){
      this.$api.POST_SPECIALGOODS({id:this.id}).then(res=>{
        if(res.status){
     this.specialGoods =  this.group(res.data,this.pageSize)
      this.total = res.data.length
        }
      })
    },
    getToggleList(){
       this.$api.POST_BARGAINLIST().then(res=>{
         if(res.status &&  res.data.length > 0)
         this.toggleList = res.data
         this.showtoggleList = true
            let id = this.$route.query.Id
             if(id){
               this.activeId = id
               this.id = id
             }else{
               if(this.toggleList.length > 0){
                 this.activeId = this.toggleList[0].id
                  this.id =  this.toggleList[0].id

               }
                 
             }        
       })
    }

  },
  created(){
    this.getToggleList()
  },
  mounted(){
  
  },
  watch:{
    type(t,f){
      if(t==1){
        this.pageSize=8;
         this.pageNumber = 1
        this.getSpecialGoods();
      }else{
        this.pageSize=20;
          this.pageNumber = 1
        this.getSpecialGoods();
      }
    },
    id(t,f){
        this.getSpecialGoods()
    }
  }
};
</script>

<style lang='scss' scoped>
.bargain-container{
  padding-bottom: 40px;
  min-height: calc(100vh - 315px);
}
.container{
  background-color: #fafafa;
  overflow: hidden;
  padding-bottom: 40px;
}
.banner {
  height: 158px;
  width: 100%;
  background: url("../../../assets/images/seckill_banner.png") no-repeat;
  background-position: center;
}
.toggle {
  width: 1200px;
  height: 56px;
  padding-left: 10px;
  margin: 16px 0;
  display: flex;
  align-items: center;
  border-radius: 28px;
  background-color: #fafafa;
  .toggle-item {
   // width: 135px;
   padding: 0 20px;
    height: 36px;
    border-radius: 18px;
    color: #505050;
    font-weight: bold;
    text-align: center;
    margin-right: 72px;
    line-height: 36px;
    font-size: 18px;
    flex-shrink: 0;
  }
  .active-toggle {
    @include font(18px, #ffffff, center, 600, 36px);
    background: linear-gradient(to right, #ff6464, #fa4b4b);
  }
}
.list-header {
  display: flex;
  justify-content: space-between;
  margin: 22px 0 24px 0;
}
.title {
  display: flex;
  align-items: center;
 
  i {
    display: inline-block;
    height: 18px;
    width: 4px;
    background-color: #fa4b4b;
    margin-right: 16px;
  }
  span{
    font-size: 16px;
    color: #333333;
  }
}
.listBtn {
  display: flex;
  border-radius: 3px;
  .list,
  .table {
    width: 72px;
    height: 26px;
    @include font(13px, #666666, center, 400, 26px);
    img {
      margin-right: 5px;
    }
  }
  .list {
    border: 1px solid #eeeeee;
    border-radius: 3px 0 0 3px;
  }
  .table {
    border: 1px solid #eeeeee;
    border-radius: 0 3px 3px 0;
  }
}
.pagination{
  text-align: center;
  margin-top: 40px;
  color: #fa4b4b;
}
.active {
  color: #f43737 !important;
  border-color: #f43737 !important;
}
.empty{
    height: 260px;
    width: 1200px;
background-color: #fdfdfd;
border-radius: 10px;
margin-top: 50px;
  @include flex-c;
.empty-img{
  margin-right: 35px;
}
  .empty-con{
     @include flex-d-c;
    h5{
      font-size: 18px;
      color: #505050;
      margin-bottom: 22px;

    }
    p{
      font-size: 16px;
      color: #808080;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/main/bargain/index.vue